import { ArrowRight, Sparkles } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/946dde8c-3f00-4713-b3bc-6f7a8b36fbbe/images/15475f6532a7c1437737acdeeae1c4bd86a7ba4ae36f8f2ea1f0c83f33d5ab25.png";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative isolate min-h-[92vh] flex items-end overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 -z-10">
        <img
          src={HERO_BG}
          alt=""
          className="h-full w-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/70 to-[#050505]" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent" />
      </div>

      <div className="max-w-7xl w-full mx-auto px-6 md:px-10 pt-36 pb-20 md:pt-40 md:pb-28">
        <div className="max-w-4xl">
          <div className="fade-up flex items-center gap-3 mb-8">
            <span className="inline-flex h-2 w-2 rounded-full bg-violet-400 shadow-[0_0_12px_2px_rgba(167,139,250,0.7)]" />
            <span
              data-testid="hero-eyebrow"
              className="font-mono-label text-[11px] text-violet-300/90"
            >
              Solo Studio · Est. by Max
            </span>
          </div>

          <h1
            data-testid="hero-heading"
            className="fade-up delay-1 font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-black leading-[0.95] tracking-tighter text-white"
          >
            Websites that look
            <br />
            <span className="italic font-light text-white/80">like nothing</span>{" "}
            <span className="text-violet-400">else.</span>
          </h1>

          <p
            data-testid="hero-subheading"
            className="fade-up delay-2 mt-8 max-w-2xl text-lg md:text-xl text-white/70 leading-relaxed font-light"
          >
            Hi, I'm <strong className="text-white font-semibold">Max</strong> — the sole
            operator behind <strong className="text-white font-semibold">Maximilian Marketing</strong>.
            I design and build <strong className="text-white font-semibold">custom, high-performance websites</strong> for
            ambitious companies that refuse to look like everyone else.
          </p>

          <div className="fade-up delay-3 mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-primary"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="cta-pill group inline-flex items-center gap-2 rounded-full px-7 py-4 text-sm font-semibold text-white"
            >
              Start a project
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="#services"
              data-testid="hero-cta-secondary"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="btn-ghost inline-flex items-center gap-2 rounded-full px-7 py-4 text-sm font-semibold text-white/90"
            >
              <Sparkles size={14} className="text-violet-400" />
              See what I build
            </a>
          </div>

          <div className="fade-up delay-4 mt-16 grid grid-cols-3 gap-6 max-w-xl">
            <Stat label="Hand-coded" value="100%" />
            <Stat label="Avg. load time" value="<1.5s" />
            <Stat label="Templates used" value="0" />
          </div>
        </div>
      </div>

      {/* Bottom marquee strip */}
      <div className="absolute bottom-0 inset-x-0 border-t border-white/5 bg-black/40 backdrop-blur-md py-3 overflow-hidden">
        <div className="flex animate-marquee whitespace-nowrap font-mono-label text-[11px] text-white/40">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center gap-12 pr-12">
              <span>· Custom Design</span>
              <span>· Hand-Coded Frontends</span>
              <span>· Brand-First Aesthetics</span>
              <span>· Performance Obsessed</span>
              <span>· One-on-One Service</span>
              <span>· Built by Max</span>
              <span>· Based in NJ · Serving Worldwide</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value }) {
  return (
    <div className="border-l border-white/10 pl-4">
      <div className="font-display text-2xl md:text-3xl font-bold text-white">{value}</div>
      <div className="font-mono-label text-[10px] text-white/40 mt-1">{label}</div>
    </div>
  );
}
